import DealFlowSpecial from "./DealFlowSpecial";

const DEBUG_PLAN = {
  price: 1,
  name: "Debug-license",
};

function DealFlowDebug() {
  return (
    <DealFlowSpecial
      licenseKey="debug_license"
      plan={DEBUG_PLAN}
      pageClassName="df-page-debug"
    />
  );
}

export default DealFlowDebug;
